import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import {
  getIsBomReportUploading,
  getBomReportUploadError,
  getBomReportUploadSuccess
} from '../selectors';
import { uploadBomReport, uploadBomReportReset } from '../actions';
import { notify } from 'features/notificationSystem/actions';
import { FormattedMessage } from 'react-intl';

const useUploadBomReport = () => {
  const dispatch = useDispatch();
  const isUploading = useSelector(getIsBomReportUploading);
  const error = useSelector(getBomReportUploadError);
  const success = useSelector(getBomReportUploadSuccess);

  const uploadBom = (file, fileName) => {
    dispatch(uploadBomReport(file));
    dispatch(
      notify({
        message: (
          <FormattedMessage
            id="notify.bomUploadInProgress"
            values={{ fileName }}
          />
        ),
        variant: 'info',
        duration: null
      })
    );
  };

  useEffect(() => {
    if (success || error) {
      dispatch(uploadBomReportReset());
    }
  }, [success, error, dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(
        notify({
          message: (
            <FormattedMessage
              id="notify.bomUploadSuccess"
              values={{ success }}
            />
          ),
          variant: 'success'
        })
      );
    }
  }, [success, dispatch]);

  return [uploadBom, success, isUploading, error];
};

export default useUploadBomReport;
